import { getWithAuthentication } from './api'
import { BASE_URL, CHAT_SESSION_INSIGHTS_ENDPOINT } from '@/assets/constants/api_endpoints'

/**
 * Fetches the insights report for a completed or abandoned chat session.
 *
 * Makes an authenticated GET request to:
 *   /chat/sessions/<sessionId>/insights/
 *
 * @param {string} sessionId - The UUID of the chat session
 * @returns {Promise<Object>} Insights object with summary, feedback, vocabulary_and_grammar, resources
 */
export async function getInsights(sessionId) {
  const endpoint = `${CHAT_SESSION_INSIGHTS_ENDPOINT}${sessionId}/insights/`
  const response = await getWithAuthentication(BASE_URL, endpoint)
  return response.data
}
